import { render, staticRenderFns } from "./intercept.vue?vue&type=template&id=4a8ddd1c&"
import script from "./intercept.vue?vue&type=script&lang=js&"
export * from "./intercept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a8ddd1c')) {
      api.createRecord('4a8ddd1c', component.options)
    } else {
      api.reload('4a8ddd1c', component.options)
    }
    module.hot.accept("./intercept.vue?vue&type=template&id=4a8ddd1c&", function () {
      api.rerender('4a8ddd1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/risk/intercept.vue"
export default component.exports